export enum SDPTimeFrameEnum {
  TH = 'TH',
  HILO = 'HILO',
  THEXN = 'THEXN',
  HILOEXN = 'HILOEXN',
  EXN = 'EXN',
}
export namespace SDPTimeFrameEnum {
  export const getTranslation = (timeFrame?: SDPTimeFrameEnum) => {
    switch (timeFrame) {
      case SDPTimeFrameEnum.TH:
        return 'overview.meter.detail.information.time.frame.th';
      case SDPTimeFrameEnum.HILO:
        return 'overview.meter.detail.information.time.frame.hilo';
      case SDPTimeFrameEnum.THEXN:
        return 'overview.meter.detail.information.time.frame.th.exn';
      case SDPTimeFrameEnum.HILOEXN:
        return 'overview.meter.detail.information.time.frame.hilo.exn';
      case SDPTimeFrameEnum.EXN:
        return 'overview.meter.detail.information.time.frame.exn';
      default:
        return '';
    }
  };
}
